<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <div class="page-header-left pl-3 pt-4">
            <h2 class="mb-1">Chi tiết công nợ khách hàng</h2>
            <div class="debt-customer-name">
              {{ currentItem.Username || ('Khách hàng #' + uId) }}
            </div>
          </div>
        </v-flex>

        <v-flex lg12>
          <v-layout row wrap class="debt-summary-row">
            <v-flex
              v-for="card in summaryCards"
              :key="card.title"
              lg4
              md4
              sm12
              xs12
              class="pa-2"
            >
              <v-card class="debt-summary-card" :class="card.className">
                <v-card-text>
                  <div class="debt-summary-label">{{ card.title }}</div>
                  <div class="debt-summary-value">{{ card.value | currency }}</div>
                  <div class="debt-summary-note">{{ card.note }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex lg12>
          <v-card class="detail-section-card">
            <v-card-title class="detail-section-title">
              Danh sách phiếu xuất kho VN
            </v-card-title>
            <v-card-text>
              <export-receipt-list :uId="uId"></export-receipt-list>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex lg12>
          <v-card class="detail-section-card">
            <v-card-title class="detail-section-title">
              Danh sách lệnh nạp tiền
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="recharge_headers"
                :items="recharges"
                :options.sync="recharge_pagination"
                :server-items-length="recharge_rows"
                :footer-props="items_per_page"
                :must-sort="true"
                :loading="recharge_loading"
                :mobile-breakpoint="100"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      {{ item.CreatedDate | display_date('DD-MM-YYYY') }}
                      <br />
                      {{ item.CreatedDate | display_date('HH:mm:ss') }}
                    </td>
                    <td :style="{ color: get_status_color(item.Status, recharge_status_list) }">
                      {{ item.Status | display_value(recharge_status_list) }}
                    </td>
                    <td>{{ item.Method | display_value(recharge_methods) }}</td>
                    <td class="text-end">{{ item.Amount | currency }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr class="total-summary-td">
                    <td colspan="3" class="text-center font-weight-bold">Tổng cộng</td>
                    <td class="text-end font-weight-bold">
                      {{ !recharge_summary ? 0 : recharge_summary.Amount | currency }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import ExportReceiptList from "@/views/ExportReceipt/list";
import _ from "lodash";

export default {
  components: {
    "export-receipt-list": ExportReceiptList
  },
  data() {
    return {
      recharge_status_list: configs.RECHARGE_STATUS_LIST,
      recharge_methods: configs.RECHARGE_METHODS,
      recharge_headers: [
        {
          text: "Ngày nạp",
          value: "CreatedDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Hình thức",
          value: "Method"
        },
        {
          text: "Số tiền",
          value: "Amount",
          align: "end"
        }
      ],
      recharge_pagination: {
        ...configs.PAGINATION,
        sortBy: ["CreatedDate"]
      },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      viewName: "bao-cao-cong-no-chi-tiet"
    };
  },
  watch: {
    recharge_pagination: {
      handler: function() {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : [];
        this.recharge_filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.report.debtReportDetail,
      recharges: state => state.rechargeHistory.all.data,
      recharge_rows: state => state.rechargeHistory.all.total,
      recharge_summary: state => state.rechargeHistory.all.summary,
      recharge_loading: state => state.rechargeHistory.loading,
    }),
    uId() {
      return Number(this.$route.params.Pid);
    },
    summaryCards() {
      const currentItem = this.currentItem || {};
      return [
        {
          title: "Tổng nạp tiền",
          value: currentItem.TotalAmount || 0,
          note: "Tổng các lệnh nạp đã duyệt",
          className: "summary-card-primary"
        },
        {
          title: "Tổng phiếu xuất",
          value: currentItem.TotalPayment || 0,
          note: "Tổng tiền của các phiếu xuất kho VN",
          className: "summary-card-warning"
        },
        {
          title: "Công nợ hiện tại",
          value: currentItem.Debt || 0,
          note: "Tổng phiếu xuất trừ tổng nạp tiền",
          className: "summary-card-danger"
        }
      ];
    }
  },
  methods: {
    filter_data: function() {
      this.$store.dispatch("report/getDebtReportDetail", this.uId);
      this.recharge_filter_data();
    },
    recharge_filter_data: function() {
      var param = {
        pagination: this.recharge_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };

      param.filter = [
        {
          column: "Status",
          value: 2,
          condition: "equal"
        },
        {
          column: "UID",
          value: this.uId,
          condition: "equal"
        }
      ];
      this.$store.dispatch("rechargeHistory/getList", param);
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
<style scoped>
.debt-customer-name {
  color: #475569;
  font-size: 15px;
  font-weight: 600;
}

.debt-summary-row {
  margin: -8px;
}

.debt-summary-card {
  border-radius: 16px;
  color: #1e293b !important;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  min-height: 160px;
}

.debt-summary-label {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  opacity: 0.92;
}

.debt-summary-value {
  margin-top: 12px;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.2;
}

.debt-summary-note {
  margin-top: 10px;
  font-size: 13px;
  opacity: 0.88;
}

.summary-card-primary {
  background: linear-gradient(135deg, #eff6ff 0%, #bfdbfe 100%);
  border: 1px solid #dbeafe;
}

.summary-card-warning {
  background: linear-gradient(135deg, #fffbeb 0%, #fde68a 100%);
  border: 1px solid #fef3c7;
}

.summary-card-neutral {
  background: linear-gradient(135deg, #f0fdfa 0%, #99f6e4 100%);
  border: 1px solid #ccfbf1;
}

.summary-card-danger {
  background: linear-gradient(135deg, #fff1f2 0%, #fecdd3 100%);
  border: 1px solid #ffe4e6;
}

.detail-section-card {
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.detail-section-title {
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e2e8f0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
}
</style>
